import Axios from "../../../Config/API";
import {
    CadastroCanalAtendimentoInterface,
    CanalAtendimentoInterface,
} from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoCanalAtendimento/CanalAtendimentoInterfaces";
import Service from "../../../Service";

export async function CadastrarCanalAtendimentoService(
    requestBody: CadastroCanalAtendimentoInterface
) {
    return Service(
        Axios.post(
            `/home/canalatendimento/cadastrarcanalatendimento`,
            requestBody
        )
    );
}

export async function getCanalAtendimentoService(idCanalAtendimento: number) {
    return Service(
        Axios.get<CanalAtendimentoInterface>(
            `/home/canalatendimento/getcanalatendimento?idCanalAtendimento=${idCanalAtendimento}`
        )
    );
}

export async function DeletarCanalAtendimentoService(
    idCanalAtendimento: number
) {
    return Service(
        Axios.delete(
            `/home/canalatendimento/deletarcanalatendimento?idCanalAtendimento=${idCanalAtendimento}`
        )
    );
}

export async function ListarCanalAtendimentoService(
    flListarTodos?: boolean | undefined
) {
    return Service(
        Axios.get<Array<CanalAtendimentoInterface>>(
            `/home/canalatendimento/listarcanalatendimentos${
                flListarTodos ? `?flListarTodos=${flListarTodos}` : ""
            }`
        )
    );
}

export async function EditarCanalAtendimentoService(
    requestBody: CanalAtendimentoInterface
) {
    return Service(
        Axios.put(
            `/home/canalatendimento/atualizarcanalatendimento`,
            requestBody
        )
    );
}
